import {
  each as _each,
  forEach as _forEach,
  head as _head,
  isUndefined as _isUndefined,
} from 'lodash-es';
import dayjs from 'dayjs';

export default {
  methods: {
    interactWithErrorBag(errors, bag) {
      const messages = errors.response.data.errors;
      _forEach(messages, (value, key) => {
        bag.add({
          field: key,
          msg: _head(value),
        });
      });
    },

    getDealers() {
      const dealersList = [];
      this.$http.get('/dealers').then((response) => {
        _each(response.data, (dealer) => {
          dealersList.push({
            name: dealer.name,
            id: dealer.id,
          });
        });
      });

      return dealersList;
    },

    getSpecificDealers() {
      const specificDealersList = [];
      this.$http.get('/dealers/specific').then((response) => {
        _each(response.data, (dealer) => {
          specificDealersList.push({
            name: dealer.name,
            id: dealer.id,
            dealer_id: dealer.dealer_id,
            managers: dealer.managers,
          });
        });
      });

      return specificDealersList;
    },

    formatDateRangeForTextField(date) {
      if (date) {
        date.filter(function (str) {
          return /\S/.test(str);
        });
        date = date.map(function (date) {
          if (date) {
            return new Date(date).toLocaleDateString('en-US');
          }
        });
      }
      return date.join('~');
    },

    goToRef(refName, routeName = null) {
      if (routeName && routeName !== this.$route.name) {
        this.$router.push({
          name: routeName,
          query: {
            goToSection: refName,
          },
        });
      }
      document.getElementById(refName).scrollIntoView({
        behavior: 'smooth',
      });
    },

    unitStatus(unit, showDueDate = false) {
      if (_isUndefined(unit)) {
        return false;
      }

      const videoPlayed = _isUndefined(unit['is_video_played'])
        ? unit['played']
        : unit['is_video_played'];
      const rewatched = _isUndefined(unit['is_rewatched'])
        ? unit['is_rewatch']
        : unit['is_rewatched'];
      const watched = _isUndefined(unit['is_finished_watching'])
        ? unit['finished_watching']
        : unit['is_finished_watching'];

      const quiz = _isUndefined(unit['is_quiz_done'])
        ? unit['answered_quiz']
        : unit['is_quiz_done'];

      if (unit.date_completed && !rewatched) {
        return 'Completed';
      }

      if (videoPlayed) {
        if (rewatched) {
          return 'Rewatched';
        } else if (watched) {
          if (!quiz) {
            return 'Quiz Not Answered';
          } else {
            return 'Completed';
          }
        }

        return 'Played';
      } else {
        if (unit['assigned_by']) {
          return showDueDate
            ? `Assigned (Due Date: ${dayjs(unit.due_date).format(
                'MMMM DD, YYYY'
              )})`
            : 'Assigned';
        } else if (unit['shared_by']) {
          return 'Shared';
        }
      }
    },
    setCurriculums() {
      this.$http.get('/client/lms/fetchCurriculums').then(({ data }) => {
        this.$store.dispatch('curriculums/setCurriculums', data);

        return true;
      });
    },

    checkTranscodeStatus(id) {
      this.axios
        .get('/client/lms/units/resync/transcodestatus/' + id)
        .then(({ data }) => {
          if (data) {
            return data.success;
          } else {
            return false;
          }
        });
    },
    setLayout(data) {
      this.$store.commit('customLayout/setCustomLayout', data);

      if (!data) {
        return;
      }

      const favicon = document.getElementById('favicon');

      localStorage.primaryColor = data.primary_color;
      localStorage.secondaryColor = data.secondary_color;
      localStorage.logoWidth = data.logo_width;
      localStorage.companyLogo = data.company_logo;
      localStorage.companyIcon = data.company_icon;
      localStorage.logoBgColor = data.logo_bgcolor;

      this.$vuetify.theme.themes.light.primary = data.primary_color;
      this.$vuetify.theme.themes.light.secondary = data.secondary_color;
      document.documentElement.style.setProperty(
        '--primary',
        data.primary_color
      );
      document.documentElement.style.setProperty(
        '--secondary',
        data.secondary_color
      );

      this.autoAdjustColor(data.primary_color);

      if (data.company_icon) {
        favicon.href = data.company_icon;
      }
    },
    autoAdjustColor(primary) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(primary);
      let rgb = result
        ? {
            red: parseInt(result[1], 16),
            green: parseInt(result[2], 16),
            blue: parseInt(result[3], 16),
          }
        : null;

      if (rgb.red >= 235 && rgb.green >= 235 && rgb.blue >= 235) {
        //WHITE
        this.$vuetify.theme.themes.light.primary = '#000000';
        this.$vuetify.theme.themes.light.primaryMain = primary;
        this.$vuetify.theme.themes.light.primaryMainText = '#000000';

        document.documentElement.style.setProperty('--primary', '#000000');
        document.documentElement.style.setProperty(
          '--primary-main-text',
          '#000000'
        );
        document.documentElement.style.setProperty('--primary-text', primary);
        document.documentElement.style.setProperty(
          '--primary-text-inverted',
          '#000000'
        );
        document.documentElement.style.setProperty(
          '--navbar-active',
          '#000000'
        );
        document.documentElement.style.setProperty(
          '--navbar-text-active',
          '#DC3522'
        );
      } else {
        this.$vuetify.theme.themes.light.primaryMain = primary;
        this.$vuetify.theme.themes.light.primaryMainText = '#000000';
        document.documentElement.style.setProperty(
          '--primary-main-text',
          '#ffffff'
        );

        document.documentElement.style.setProperty(
          '--navbar-active',
          '#000000'
        );
        document.documentElement.style.setProperty(
          '--primary-text-inverted',
          '#ffffff'
        );
        document.documentElement.style.setProperty(
          '--navbar-text-active',
          primary
        );
      }

      if (rgb.red <= 60 && rgb.green <= 60 && rgb.blue <= 60) {
        //BLACK
        this.$vuetify.theme.themes.light.primaryMainInverted = '#ffffff';

        document.documentElement.style.setProperty(
          '--primary-inverted',
          '#ffffff'
        );
        document.documentElement.style.setProperty('--primary-text', '#ffffff');
        document.documentElement.style.setProperty(
          '--primary-text-inverted',
          '#ffffff'
        );
        document.documentElement.style.setProperty(
          '--navbar-active',
          '#ffffff'
        );
        document.documentElement.style.setProperty(
          '--navbar-text-active',
          '#DC3522'
        );
      } else {
        document.documentElement.style.setProperty(
          '--primary-inverted',
          primary
        );
        document.documentElement.style.setProperty(
          '--primary-text-inverted',
          '#000000'
        );
        this.$vuetify.theme.themes.light.primaryMainInverted = primary;
      }
    },
  },
};
